
import { Vue } from "vue-class-component";

export default class WarningCircle extends Vue {}
